export const impressionsSourceId = "impressions";
export const impressionsClusterLayerId = "impressionsCluster";
export const impressionsPointsLayerId = "impressionsPoints";
export const impressionsClusterCountLayerId = "impressionsClusterCount";

export const topicsSourceId = "topics";
export const topicsClusterLayerId = "topicsCluster";
export const topicsPointsLayerId = "topicsPoints";
